// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e0bcedd","584":"4fd1a0e6","619":"8eaa7734","692":"569132c7","871":"34e4b774"}[chunkId] + ".chunk.js";
};